export const RAW_ORDER_REQUEST = "RAW_ORDER_REQUEST";
export const RAW_ORDER_SUCCESS = "RAW_ORDER_SUCCESS";
export const RAW_ORDER_FAILED = "RAW_ORDER_FAILED";
